import { SxStyle } from '@aibees/shared/theme';

export const errorIcon: SxStyle = {
  color: (p) => p.palette.error[200],
};
